import React from 'react'

const ArticleTag = props => (
    <div className="art-tag-display">{props.tag}</div>
)

export default ArticleTag